<template>
  <memlist-modal size="xl" ref="post-modal">
    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="post_id"
          name="post_id"
          title="ID"
          layout="vertical"
          v-model="local_post.id"
          :disabled="true"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="author"
          name="author"
          title="Author"
          layout="vertical"
          v-model="local_post.author"
          :disabled="true"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="created_at"
          name="created_at"
          title="Created"
          layout="vertical"
          v-model="local_post.created_at"
          :disabled="true"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="city"
          name="city"
          title="City"
          layout="vertical"
          v-model="local_post.city"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="12">
        <memlist-textarea
          id="text"
          name="text"
          title="Message"
          layout="vertical"
          v-model="local_post.text"
          rows="12"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="12">
        <label class="form-label d-block mb-2">Tags</label>
        <memlist-badge
          v-for="tag in local_post.tags"
          :key="tag.id"
          class="mr-1 mb-2 tags"
        >
          {{ tag.name }}
        </memlist-badge>
      </m-col>
    </m-row>

    <m-row class="mt-4">
      <m-col lg="12">
        <RightModalSaveAndCloseButtons
          :text="$t('COMMON.SAVE')"
          :spin="true"
          @click="on_submit"
          @close="close"
          ref="saveButton"
        />
      </m-col>
    </m-row>
  </memlist-modal>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'ForumPostEditorModal',
  props: ['post_id'],
  mixins: [toasts],
  emits: ['updated'],
  data() {
    return {
      local_post_id: null,
      local_post: {}
    };
  },
  watch: {
    post_id: {
      immediate: true,
      async handler(val) {
        this.local_post_id = val;
        if (val) {
          const post = await this.fetch_post(val);
          this.local_post = post || {};
        } else {
          this.local_post = {};
        }
      }
    }
  },
  methods: {
    show() {
      this.$refs['post-modal'].show();
    },
    close() {
      this.$refs['post-modal'].hide();
    },
    async on_submit() {
      this.$refs['saveButton'].start();

      const result = await this.update_post(this.local_post.id, this.local_post);

      if (result) {
        this.$emit('updated', result);
        this.close();
      }

      this.$refs['saveButton'].stop();
    },
    async fetch_post(id) {
      try {
        const res = await axios.get(`/forum_post/${id}`);
        if (res.status === 200) return res.data;
      } catch (err) {
        console.error('fetch_post error', err);
      }
      return null;
    },
    async update_post(id, data) {
      try {
        const res = await axios.put(`/forum_post/${id}`, data);
        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.UPDATED'));
          return res.data;
        }
      } catch (err) {
        console.error('update_post error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_UPDATE'));
      return null;
    }
  }
};
</script>


<style scoped>
.tags {
  max-width: 120px;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 4px;
}
</style>